import React from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetPendingTerminationReport from "./hooks/useGetPendingTerminationReport";
import { CSVLink } from "react-csv";
import { UsersIcon } from "@heroicons/react/24/solid";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { employeeFromReports } from "../../Employees/Confie/atoms/atoms";
import { EmployeeTabs } from "../../../EmployeeTab/EmployeeTab";
import DownloadButton from "../../../../components/DownloadButton";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IPendingTerminationReport {
  employeenumber: string;
  fullname: string;
  title: string;
  status: string;
  officeName: string;
  reportsToFullname: string;
  terminationdate: string;
  updateApproved: string;
  terminatedBy: string;
}
export const PendingTerminationReport = () => {
  const { data: pendingTermination, isLoading: pendingTerminationLoading } =
    useGetPendingTerminationReport();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setShowFromReports] = useRecoilState(employeeFromReports);
  const user = useRecoilValue(accountAtom);

  //Format Date
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }

  //For downloading table data
  const exportdata = pendingTermination
    ?.filter((x) =>
      user.isFranchise && user.isNonFranchise
        ? x.employeeTypeName !== ""
        : user.isFranchise
        ? x.employeeTypeName?.toLowerCase() === "franchise"
        : x.employeeTypeName?.toLowerCase() !== "franchise"
    )
    .map((emp: IPendingTerminationReport) => {
      return {
        "Employee ID": '=""' + emp.employeenumber + '""',
        "Employee Name": emp.fullname,
        Title: emp.title,
        "Office Location": emp.officeName,
        "Reports To": emp.reportsToFullname,
        Status: emp.status,
        "Termination Date": emp.terminationdate
          ? formatDate(emp.terminationdate)
          : "",
        "Update Approved": emp.updateApproved,
        "Modified By (HR User)": emp.terminatedBy,
      };
    });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "PendingTerminationReport_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };
  const employeeColumns = [
    { title: "Employee ID", field: "employeenumber" },
    {
      title: "Employee Name",
      field: "fullname",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/employeetab/employee";
              history.push({
                pathname: url,
                state: {
                  employeeNumber: rowData?.employeeid,
                  action: "EmployeePendingTerminationReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...EmployeeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
              setShowFromReports(true);
            }}
          >
            <span className="text-quinary font-bold underline text-sm ">
              {rowData.fullname}
            </span>
          </div>
        );
      },
    },
    { title: "Title", field: "title" },
    { title: "Office Location", field: "officeName" },
    { title: "Reports To", field: "reportsToFullname" },
    { title: "Status", field: "status" },
    {
      title: "Termination Date",
      field: "terminationdate",
      render: (rowDetails) => {
        return (
          <div>
            <span className=" ">
              {rowDetails.terminationdate
                ? formatDate(rowDetails.terminationdate)
                : ""}
            </span>
          </div>
        );
      },
    },
    { title: "Update Approved", field: "updateApproved" },
    { title: "Modified By (HR User)", field: "terminatedBy" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Employees & Offices
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Pending Termination Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {user.isFranchise && user.isNonFranchise
                  ? pendingTermination?.length
                  : pendingTermination?.filter(
                      (x) =>
                        x.employeenumber !== "" &&
                        (user.isFranchise
                          ? x.employeeTypeName?.toLowerCase() === "franchise"
                          : x.employeeTypeName?.toLowerCase() !== "franchise")
                    )?.length}
              </span>
            </div>

            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={
              user.isFranchise && user.isNonFranchise
                ? pendingTermination
                : pendingTermination?.filter(
                    (x) =>
                      x.employeenumber !== "" &&
                      (user.isFranchise
                        ? x.employeeTypeName?.toLowerCase() === "franchise"
                        : x.employeeTypeName?.toLowerCase() !== "franchise")
                  )
            }
            isLoading={pendingTerminationLoading}
            columns={employeeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
